const prefixedStorage = function (prefix, storageType = 'sessionStorage') {
  const storage = window[storageType]
  const keySubscribers = {}
  const getSubscribers = (key) => {
    if (!keySubscribers[key]) {
      keySubscribers[key] = []
    }
    return keySubscribers[key]
  }
  return {
    has (key) {
      return Boolean(storage.getItem(`${prefix}.${key}`))
    },
    set (key, newValue) {
      const oldValue = storage.getItem(`${prefix}.${key}`)
      storage.setItem(`${prefix}.${key}`, newValue)
      getSubscribers(key).forEach(cb => cb(newValue, oldValue))
    },
    get (key) {
      return storage.getItem(`${prefix}.${key}`)
    },
    remove (key) {
      const oldValue = storage.getItem(`${prefix}.${key}`)
      storage.removeItem(`${prefix}.${key}`)
      const newValue = storage.getItem(`${prefix}.${key}`)

      getSubscribers(key).forEach(cb => cb(newValue, oldValue))
    },
    subscribe (key, cb) {
      if (typeof key !== 'string') {
        throw new Error('Subscribe parameter 1 must be a function. ')
      }
      if (typeof cb !== 'function') {
        throw new Error('Subscribe parameter 2 must be a function. ')
      }
      const subscribers = getSubscribers(key)
      subscribers.push(cb)

      return function unsubscribe () {
        const index = subscribers.indexOf(cb)
        if (index >= 0) {
          subscribers.splice(index, 1)
        }
      }
    }
  }
}

export default prefixedStorage
